































import Vue from "vue";
import { computed } from "@vue/composition-api";
import { useGenAiPalette } from "../../data/design";
import { Level, SENSITIVITY_LABEL } from "./event-view";

const MARK: Record<Level, string> = { high: "H", medium: "M", low: "L", none: "—" };

export default Vue.extend({
  props: {
    level: { type: String, default: "none" },
    size: { type: String, default: "md" },
    variant: { type: String, default: "solid" },
    show_label: { type: Boolean, default: false },
  },
  setup(props) {
    const T = useGenAiPalette();
    const level = computed(() => (props.level || "none") as Level);
    const tone = computed(() => T.value.sensitivity[level.value]);
    const label = computed(() => SENSITIVITY_LABEL[level.value]);
    const mark = computed(() => MARK[level.value]);
    const box = computed(() => {
      const sm = props.size === "sm";
      const base = {
        width: sm ? "20px" : "24px",
        height: sm ? "20px" : "24px",
        borderRadius: sm ? "4px" : "6px",
        fontSize: sm ? "10px" : "11px",
      };
      return props.variant === "soft"
        ? {
            ...base,
            background: tone.value.chipBg,
            color: tone.value.chipText,
            border: "1px solid " + tone.value.dot + "40",
          }
        : { ...base, background: tone.value.dot, color: "#FFFFFF" };
    });
    return { T, tone, label, mark, box };
  },
});
